import styled from 'styled-components';

const HouseSmartStickyNavStyles = styled.section`
  position: relative;
  overflow: hidden;
  .ga-housesmart-sticky-builtsmart {
    background: #ef4b5d;
  }
  .ga-housesmart-sticky-designsmart {
    background: #352269;
  }
  .ga-housesmart-sticky-energysmart {
    background: #00b0ac;
  }
  .ga-housesmart-sticky-budgetsmart {
    background: #ffc50a;
  }
  ul {
    position: fixed;
    right: 0;
    top: 50%;
    bottom: 50%;
    z-index: 7;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    list-style: none;

    li {
      margin: 0;
      line-height: 0;
      transform: translateX(204px);

      cursor: pointer;
    }
  }
  .navbar.page-loaded {
    li {
      transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
    }
  }
  .navbar {
    li {
      transform: translateX(279px);
    }
  }
  .navbar.visible {
    li {
      transform: translateX(204px);

      &:hover {
        transform: translateX(0px);
      }
    }
  }
`;

export default HouseSmartStickyNavStyles;
